
import { useEffect } from 'react'

const PIXEL_ID = '1328280338767913'

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
    _fbq?: (...args: unknown[]) => void
    requestIdleCallback?: (
      callback: () => void,
      options?: { timeout: number },
    ) => number
  }
}

type PixelQueue = {
  (...args: unknown[]): void
  callMethod?: (...args: unknown[]) => void
  queue: unknown[][]
  push: PixelQueue
  loaded: boolean
  version: string
}

let initialized = false

function initPixel() {
  if (
    initialized ||
    typeof window === 'undefined' ||
    typeof document === 'undefined'
  ) {
    return
  }

  initialized = true

  if (!window.fbq) {
    const pixelQueue: PixelQueue = function (...args: unknown[]) {
      if (pixelQueue.callMethod) {
        pixelQueue.callMethod(...args)
        return
      }
      pixelQueue.queue.push(args)
    }

    pixelQueue.push = pixelQueue
    pixelQueue.queue = []
    pixelQueue.loaded = true
    pixelQueue.version = '2.0'

    window.fbq = pixelQueue
    if (!window._fbq) window._fbq = pixelQueue

    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(script)
  }

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

function scheduleInit() {
  if (typeof window === 'undefined') return

  const runWhenIdle = () => {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(initPixel, { timeout: 5000 })
      return
    }

    initPixel()
  }

  if (document.readyState === 'complete') {
    runWhenIdle()
    return
  }

  window.addEventListener('load', runWhenIdle, { once: true })
}

export function useMetaPixel() {
  useEffect(() => {
    scheduleInit()
  }, [])
}

